/*
 * Bulg PDP size behaviour (loaded only when a <variant-selects data-default-size>
 * is present, i.e. vendor == Bulg):
 *   1) Default the picked size to L on load.
 *   2) If the customer never picks a size, intercept Add-to-cart / Buy-now with a
 *      blocking confirm popup so they can't silently buy the L default.
 * Self-gating + fail-open: respects an explicit ?variant=, and if the size
 * fieldset can't be found it simply lets the action through (no breakage).
 *
 * CONSISTENCY: the theme updates the hidden input[name="id"] ASYNCHRONOUSLY
 * (product-info fetches a section, then sets the id). Selecting a size and
 * submitting immediately would post the stale variant. So any size change made
 * here marks `pendingVariant` and we only proceed once the id input has settled
 * (its change event) — guaranteeing the size shown == the size added.
 */
(function () {
  var state = { touched: false, confirmed: false, pendingVariant: false };

  function sizeFieldset() { return document.querySelector('[data-bulg-size]'); }
  function productForm(node) {
    return (node && node.closest && node.closest('form[data-type="add-to-cart-form"], form.main-product-form'))
      || document.querySelector('form[data-type="add-to-cart-form"], form.main-product-form');
  }
  function currentDefault() {
    var vs = document.querySelector('variant-selects[data-default-size]');
    return (vs && vs.getAttribute('data-default-size')) || 'L';
  }
  function guardActive() { return !!sizeFieldset() && !state.touched && !state.confirmed; }

  function selectSize(radio) {
    radio.checked = true;
    state.pendingVariant = true;                 // the id input will update async
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Run `proceed` only once the hidden variant id reflects the current selection.
  function proceedWhenSettled(proceed) {
    if (!state.pendingVariant) { proceed(); return; }
    var done = false;
    function go() { if (done) return; done = true; document.removeEventListener('change', onCh, true); clearTimeout(t); proceed(); }
    function onCh(e) { if (e.target && e.target.matches && e.target.matches('input[name="id"]')) go(); }
    document.addEventListener('change', onCh, true);
    var t = setTimeout(go, 2500);                 // fail-safe so we never hang the purchase
  }

  // --- 1) preselect the default size (skip if a variant is pinned in the URL) ---
  function preselect() {
    if (new URLSearchParams(location.search).has('variant')) return;
    document.querySelectorAll('variant-selects[data-default-size]').forEach(function (vs) {
      var size = vs.getAttribute('data-default-size'); if (!size) return;
      var scope = vs.querySelector('[data-bulg-size]') || vs;
      var radio = null;
      scope.querySelectorAll('input[type="radio"][value="' + size + '"]').forEach(function (r) {
        if (!r.classList.contains('disabled')) radio = r;   // skip sold-out
      });
      if (radio) { if (!radio.checked) selectSize(radio); return; }
      scope.querySelectorAll('select').forEach(function (s) {
        var opt = Array.prototype.find.call(s.options, function (o) { return o.value === size && !o.classList.contains('disabled'); });
        if (opt && s.value !== size) { s.value = size; state.pendingVariant = true; s.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
  }

  // --- 2) clear `pendingVariant` once the theme has updated the hidden id ---
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="id"]')) state.pendingVariant = false;
  }, true);

  // --- a real (trusted) size pick clears the guard ---
  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;                 // ignore the programmatic preselect above
    var fs = sizeFieldset();
    if (fs && fs.contains(e.target)) state.touched = true;
  }, true);

  // --- popup ---
  function injectStyles() {
    if (document.getElementById('bulg-sizeconfirm-css')) return;
    var s = document.createElement('style');
    s.id = 'bulg-sizeconfirm-css';
    s.textContent =
      '.bscbg{position:fixed;inset:0;background:rgba(12,16,30,.5);z-index:1100;display:flex;align-items:center;justify-content:center;padding:20px}' +
      '.bsc{position:relative;background:#fff;border-radius:16px;max-width:340px;width:100%;padding:22px 20px;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,.25)}' +
      '.bsc__x{position:absolute;top:8px;right:10px;border:0;background:none;font-size:24px;line-height:1;cursor:pointer;color:#8a8a8a}' +
      '.bsc__t{margin:0 0 6px;font-size:18px;font-weight:800}' +
      '.bsc__p{margin:0 0 14px;font-size:14px;line-height:1.4;color:#42485a}' +
      '.bsc__pills{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-bottom:16px}' +
      '.bsc__pill{min-width:46px;padding:9px 12px;border-radius:10px;border:1.5px solid #d7d2c6;background:#fff;font-weight:700;cursor:pointer}' +
      '.bsc__pill.on{border-color:#0b3c49;background:#0b3c49;color:#fff}' +
      '.bsc__pill[disabled]{opacity:.4;cursor:not-allowed;text-decoration:line-through}' +
      '.bsc__cta{width:100%;padding:13px;border:0;border-radius:12px;background:#0b3c49;color:#fff;font-weight:800;font-size:15px;cursor:pointer}' +
      '.bsc__cta[aria-busy="true"]{opacity:.7;cursor:progress}';
    document.head.appendChild(s);
  }

  function openPopup(proceed) {
    injectStyles();
    var fs = sizeFieldset();
    var def = currentDefault();
    var radios = fs ? Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')) : [];
    var bg = document.createElement('div');
    bg.className = 'bscbg';
    var pills = radios.map(function (r) {
      var dis = r.classList.contains('disabled') ? ' disabled' : '';
      return '<button type="button" class="bsc__pill' + (r.value === def ? ' on' : '') + '" data-s="' + r.value + '"' + dis + '>' + r.value + '</button>';
    }).join('');
    bg.innerHTML = '<div class="bsc" role="dialog" aria-modal="true" aria-label="Confirm your size">' +
      '<button type="button" class="bsc__x" aria-label="Close">&times;</button>' +
      '<h3 class="bsc__t">Confirm your size</h3>' +
      '<p class="bsc__p">Your size is set to <b>' + def + '</b>. Pick your size or continue.</p>' +
      '<div class="bsc__pills">' + pills + '</div>' +
      '<button type="button" class="bsc__cta">Continue with ' + def + '</button>' +
    '</div>';
    function close() { bg.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    function commit() {                          // wait for the id to settle, then go
      state.confirmed = true;
      var cta = bg.querySelector('.bsc__cta');
      if (cta) cta.setAttribute('aria-busy', 'true');
      proceedWhenSettled(function () { close(); proceed(); });
    }
    bg.addEventListener('click', function (e) {
      if (e.target === bg || e.target.closest('.bsc__x')) { close(); return; }
      var pill = e.target.closest('.bsc__pill');
      if (pill && !pill.disabled) {
        var r = radios.filter(function (x) { return x.value === pill.dataset.s; })[0];
        if (r) selectSize(r);                    // marks pendingVariant
        state.touched = true; commit(); return;
      }
      if (e.target.closest('.bsc__cta')) { commit(); }
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(bg);
  }

  // --- 3) intercept Add-to-cart (form submit, capture phase = before product-form) ---
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"], form.main-product-form')) return;
    if (!form.querySelector('[data-bulg-size]') || !guardActive()) return;
    var submitter = e.submitter;
    e.preventDefault();
    e.stopImmediatePropagation();
    openPopup(function () {
      if (form.requestSubmit) form.requestSubmit(submitter || undefined);
      else form.submit();
    });
  }, true);

  // --- 3b) intercept Buy-now / dynamic checkout (best-effort; Shop Pay iframe may bypass) ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.shopify-payment-button button, .shopify-payment-button [role="button"]');
    if (!btn) return;
    var form = productForm(btn);
    if (!form || !form.querySelector('[data-bulg-size]') || !guardActive()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openPopup(function () { btn.click(); });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preselect);
  else preselect();
})();
